import { useEffect } from 'react';
import { useAuth } from '@clerk/clerk-react';
import { setTokenGetter } from '../client';

/**
 * Hook to initialize the API client with Clerk authentication
 * This should be called once at the app level
 */
export function useApiClient() {
  const { getToken } = useAuth();

  useEffect(() => {
    // Set the token getter function for the API client
    setTokenGetter(async () => {
      try {
        return await getToken();
      } catch (error) {
        console.warn('Failed to get auth token:', error);
        return null;
      }
    });
  }, [getToken]);
}

